import ServiceRequestDetail from './service-request-detail.container'

export default ServiceRequestDetail